
import { useProgress, Center, Text3D } from "@react-three/drei"
import { Canvas, extend, useThree } from "@react-three/fiber";
import Box from "./starter/Box";
import Timerloader from "./starter/Timerloader";
export default function Wait() {

    return <Canvas
        flat
        camera={{
            fov: 45,
            near: 0.1,
            far: 200
        }}>
        <color args={['#000000']} attach="background" />
        <Center top>
            <Box />
        </Center>
        <Timerloader />
    </Canvas >


}